module.exports = {
  fetch: `
    query getCaseConfigurations($offset: Int, $limit: Int, $sortBy: String, $search: String, $filter: CaseConfigurationFilterInput) {
      caseConfigurations(offset: $offset, limit: $limit, sortBy: $sortBy, search: $search, filter: $filter) {
        id
        name
        patientName
        tags {
          text
        }
        dispatch {
          learningObjectives {
            caption {
              en
            }
            displayed
          }
          chiefComplaint {
            caption {
              en
            }
            displayed
          }
        }
        isFavorite
        isTemplate
        shares {
          from
          shareType
          to
        }
        errorsCount
        warningsCount
        lastAccessed
        lastPlayed
        createdAt
        updatedAt
        needsEcUpdate
        ignoreEcUpdate
        outdatedEcNodes
        outdatedMedications {
          id
          name {
            en
            es
          }
        }
        access {
          owner
          ownerOrg
          read {
            groups
            users
            roles
          }
          write {
            groups
            users
            roles
          }
          run {
            groups
            users
            roles
          }
          share {
            groups
            users
            roles
          }
        }
        searchableText
        _avatar {
          id
          key
          name {
            en
          }
          picture {
            url
          }
        }
        _startLocation {
          id
          name {
            en
          }
          picture {
            url
          }
        }
        _endLocation {
          id
          name {
            en
          }
          picture {
            url
          }
        }
      }
    }
  `,
  fetchById: `
    query getCaseConfiguration($id: ID) {
      caseConfigurations (id: $id) {
        id
        name
        timer {
          hours
          minutes
          seconds
        }
        avatarKey
        voiceKey
        description
        lastAccessed
        lastPlayed
        createdAt
        updatedAt
        dispatch {
          learningObjectives {
            caption {
              en
            }
            displayed
          }
          chiefComplaint {
            caption {
              en
            }
            displayed
          }
          goal {
            caption {
              en
            }
            displayed
          }
          codeStatuses
          certificationLevels
          scenarioScript
        }
        caseLogicDescription
        outdatedEcNodes
        outdatedMedications {
          id
        }
        pacing
        language
        type
        advancedGrading
        physicalAssessments
        moulages
        structuralMoulages
        availableInterventions {
          available
          key
          availableComponents {
            key
          }
          availableLocations
        }
        spinalAssessments {
          key
        }
        tags {
          text
        }
        endConditions {
          stateKey
          operator
          value
        }
        access {
          owner
          ownerOrg
          read {
            groups
            users
            roles
          }
          write {
            groups
            users
            roles
          }
          run {
            groups
            users
            roles
          }
          share {
            groups
            users
            roles
          }
        }
        completedStepsCount
        dialogue {
          questions {
            id
            content {
              en
            }
            options {
              position
              enabled
              answer {
                en
              }
            }
          }
          commands {
            id
            content {
              en
            }
            options {
              position
              enabled
            }
          }
          unsolicited {
            id
            options {
              position
              answer {
                en
              }
            }
          }
          calls {
            id
            callee {
              en
            }
            calleeVoiceId
            items {
              id
              content {
                en
              }
              options {
                position
                enabled
                answer {
                  en
                }
              }
            }
            unsolicited {
              id
              options {
                position
                answer {
                  en
                }
              }
            }
          }
          aiEnabled
          patientPrompt {
            markup {
              en
              es
            }
            content {
              en
              es
            }
          }
          useCurrentDate
          aiQuestions {
            id
            content {
              en
            }
            options {
              position
              enabled
              answer {
                en
              }
              response
              reason {
                en
              }
            }
          }
          aiUnsolicited {
            id
            options {
              position
              answer {
                en
              }
              reason {
                en
              }
            }
          }
        }
        monitorMetadata {
          monitorModel
        }
        errorsCount
        warningsCount
        warningsHidden
        grading {
          questions {
            id
            component
            componentKey
            subComponentKey
            grade
            points
            isCritical
          }
          commands {
            id
            component
            componentKey
            subComponentKey
            grade
            points
            isCritical
          }
          calls {
            id
            component
            componentKey
            subComponentKey
            grade
            points
            isCritical
          }
          assessments {
            id
            component
            componentKey
            subComponentKey
            grade
            points
            isCritical
          }
          treatments {
            id
            component
            componentKey
            subComponentKey
            grade
            points
            isCritical
          }
          medications {
            id
            component
            componentKey
            subComponentKey
            grade
            points
            isCritical
          }
          fluids {
            id
            component
            componentKey
            subComponentKey
            grade
            points
            isCritical
          }
          oxygenRoutes {
            id
            component
            componentKey
            subComponentKey
            grade
            points
            isCritical
          }
          interventions {
            id
            component
            componentKey
            subComponentKey
            grade
            points
            isCritical
          }
          customMenus {
            id
            component
            componentKey
            subComponentKey
            grade
            points
            isCritical
          }
          outputPreference
          aiAssessmentEnabled
          aiAssessmentPrompt {
            markup {
              en
            }
            content {
              en
            }
          }
        }
        iv {
          enabled
          bagCount
          allowPorts
          allowMultiLumen
          dropSet {
            enabled
            minGTTM
            maxGTTM
            dripSet
          }
          pump {
            enabled
            allowTitrate
            allowOptions
          }
          types {
            type
            ports
            matchSides
            salineLock
            sites {
              site
              sides
            }
            gauges
          }
        }
        initialIvs {
          id
          categoryType
          site
          side
          portAmount
          needle
          salineLock
          isRemovable
        }
        initialMedications {
          id
          medOrFluidId
          volume
          treatmentType
          isDropSetEnabled
          rate
          dripSet
          isIvPumpEnabled
          isIvPumpSecondary
          isIvPumpSecondaryActive
          ivPumpPrimary {
            pumpFunction
            vtbi
            rate
            weight
            formulary {
              dose
              dosing
              volume
            }
            hours
            minutes
          }
          ivPumpSecondary {
            pumpFunction
            vtbi
            rate
            weight
            formulary {
              dose
              dosing
              volume
            }
            hours
            minutes
          }
          connection {
            type
            id
            port
          }
          isAlreadyRunning
          runningForHour
          runningForMinutes
        }
        dosageForms {
          id
          medicationId
          description
          dosageFormType
          concentration {
            numeratorValue
            numeratorUnits
            denominatorValue
            denominatorUnits
          }
          enabledRoutes {
            key
            options {
              pushTimeframes
              infusionBagVolumes
              infusionDosingTypes
              formularyEnabled
              formularies {
                dose
                dosing
                volume
              }
            }
          }
          useDefaultEffectChain
          customEffectChainId
          administeringUnits
        }
        customMedications {
          id
          key
          name {
            en
            es
          }
          description
          effectChainId
          effectChain
          routes {
            key
            name {
              en
              es
            }
            enabled
            isDefault
            defaultDosingTypes
            defaultBagVolumes
            defaultFluidColor
            defaultFormularies {
              dose
              dosing
              volume
            }
            defaultPushTimeframes
          }
          group
          dosageForm
          defaultConcentration {
            numeratorValue
            numeratorUnits
            denominatorValue
            denominatorUnits
          }
          defaultAdministeringUnit
        }
        customMedGroups {
          key
          label {
            en
            es
          }
        }
        fluids {
          id
          key
          description
          infusionBagVolumes
          infusionDosingTypes
          formularies {
            dose
            dosing
            volume
          }
        }
        customFluids {
          key
          label {
            en
            es
          }
          abbreviation {
            en
            es
          }
          availableBagVolumes
        }
        customMenus {
          category
          buttonLabel {
            en
            es
          }
          iconKey
          items {
            id
            content {
              en
              es
            }
            options {
              position
              enabled
            }
            children {
              id
              content {
                en
                es
              }
              options {
                position
                enabled
              }
            }
          }
        }
        outfit {
          clothingType
          isDirty
          onAtStart
        }
        patientName
        _avatar {
          id
          key
          name {
            en
            es
          }
          picture {
            url
          }
          avatarOptions {
            upperUnderwear
            bodyType
            genderType
            defaultOutfit
            defaultIslamicOutfit
          }
          options {
            id
          }
        }
        _sounds {
          id
          category
          resourceName
          preview {
            url
          }
          options {
            id
            orientation
            position
            type
            volume
          }
        }
        _monitors {
          id
          key
          name {
            en
            es
          }
          options {
            id
            enabled
          }
        }
        _oxygens {
          id
          name {
            en
            es
          }
          options {
            __typename
            ...on BaseTreatmentOptions {
              id
              enabled
            }
          }
        }
        _treatments {
          id
          name {
            en
            es
          }
          category
          options {
            __typename
            ...on BaseTreatmentOptions {
              id
              enabled
              componentOptions
            }
            ...on IVTreatmentOptions {
              id
              enabled
              componentOptions
            }
          }
        }
        _labAssets {
          id
          key
          options {
            ...on SingleValuedLabAssetOptions {
              id
              asset {
                ...LabAssetValue
              }
              __typename
            }
            ...on MultiValuedLabAssetOptions {
              id
              assets {
                ...LabAssetValue
              }
              __typename
            }
          }
        }
        _assessments {
          id
          name {
            en
            es
          }
          options {
            __typename
            ...on BaseAssessmentOptions {
              id
              enabled
            }
            ...on PhysicalAssessmentOptions {
              id
              enabled
              finding {
                en
              }
            }
          }
        }
        _startLocation {
          id
          key
          name {
            en
            es
          }
          picture {
            url
          }
          options {
            id
          }
        }
        _endLocation {
          id
          key
          name {
            en
            es
          }
          picture {
            url
          }
          options {
            id
          }
        }
        _initialStates {
          id
          options {
            id
            value
          }
        }
        initialConditions {
          pulses {
            location
            strength
          }
          leftEye {
            state
            nonreactive
          }
          rightEye {
            state
            nonreactive
          }
          disablePulseBpSync
          disablePulseStrengthsMatching
          height
          weight
        }
        measurementSystem
        temperatureUnits
        attentionInfo {
          user
          npcs {
            key
            attentionType
          }
        }
        npcs {
          key
          avatarKey
          name
          activeScenes
          complexionKey
          voiceKey
          outfit {
            clothingType
            isDirty
            onAtStart
          }
          role
          dialogue {
            questions {
              id
              content {
                en
              }
              options {
                position
                enabled
                answer {
                  en
                }
              }
            }
            commands {
              id
              content {
                en
              }
              options {
                position
                enabled
              }
            }
            unsolicited {
              id
              options {
                position
                answer {
                  en
                }
              }
            }
            prompt {
              markup {
                en
                es
              }
              content {
                en
                es
              }
            }
            aiQuestions {
              id
              content {
                en
              }
              options {
                position
                enabled
                answer {
                  en
                }
                response
                reason {
                  en
                }
              }
            }
            aiUnsolicited {
              id
              options {
                position
                answer {
                  en
                }
                reason {
                  en
                }
              }
            }
          }
          attentionInfo {
            patient
            user
          }
        }
      }
    }

    fragment LabAssetValue on LabAssetValue {
      ... on FloatLabAsset {
        enabled
        value
      }
      ... on ImageLabAsset {
        enabled
        url
      }
      ... on NamedImageLabAsset {
        enabled
        url
        name
      }
      __typename
    }
    `,
  save: `mutation saveCaseConfiguration($value: CaseConfigurationInput) {
      upsertCaseConfiguration(caseConfiguration: $value) {
        id
        name
        timer {
          hours
          minutes
          seconds
        }
        tags {
          text
        }
        _avatar {
          id
          key
          name {
            en
          }
          picture {
            url
          }
        }
        _startLocation {
          name {
            en
          }
        }
      }
    }`,
  add: `mutation addCaseConfiguration($value: CaseConfigurationInput) {
      upsertCaseConfiguration(caseConfiguration: $value) {
        id
        name
        tags {
          text
        }
        _avatar {
          id
          key
          name {
            en
          }
          picture {
            url
          }
        }
        _startLocation {
          name {
            en
          }
        }
        access {
          owner
          ownerOrg
          read {
            groups
            users
            roles
          }
          write {
            groups
            users
            roles
          }
          run {
            groups
            users
            roles
          }
          share {
            groups
            users
            roles
          }
        }
        dialogue {
          questions {
            id
            content {
              en
            }
            options {
              position
              enabled
              answer {
                en
              }
            }
          }
          commands {
            id
            content {
              en
            }
            options {
              position
              enabled
            }
          }
          unsolicited {
            id
            options {
              position
              answer {
                en
              }
            }
          }
          calls {
            id
            callee {
              en
            }
            calleeVoiceId
            items {
              id
              content {
                en
              }
              options {
                position
                enabled
                answer {
                  en
                }
              }
            }
          }
          aiEnabled
          patientPrompt {
            markup {
              en
              es
            }
            content {
              en
              es
            }
          }
          aiQuestions {
            id
            content {
              en
            }
            options {
              position
              enabled
              answer {
                en
              }
              response
              reason {
                en
              }
            }
          }
          aiUnsolicited {
            id
            options {
              position
              answer {
                en
              }
              reason {
                en
              }
            }
          }
        }
      }
    }`,
  remove: `
    mutation removeCaseConfigurations($ids: [ID]) {
      bulkRemoveCaseConfigurations(ids: $ids)
    }
  `,
  duplicate: `
    mutation duplicateCaseConfiguration($id: String, $newCaseName: String) {
      duplicateCases(caseIds: [$id], newCaseNames: [$newCaseName])
    }
  `,
  addFavorite: `
    mutation addFavorite($id: String) {
      addFavorite(caseId: $id)
    }
  `,
  removeFavorite: `
    mutation removeFavorite($id: String) {
      removeFavorite(caseId: $id)
    }
  `,
  updateCasesEffectChains: `
    mutation updateCasesEffectChains($caseIds: [String!]) {
      updateCasesEffectChains(caseIds: $caseIds)
    }
  `
};
